import type { FeatureFlag as FF } from 'feature-flags/types'

export interface FeatureFlag {
	enabled: FF['enabled']
	variables: {
		isDRSEnabled: boolean
	}
}

export interface MyTSAccountProtection {
	clearUser: () => void
	init: () => void
	setAuthenticatedUser: (userId: string) => void
	triggerActionEvent: (actionType: string) => Promise<{ actionToken: string }>
}

export enum ActionTypes {
	CHECKOUT = 'checkout',
	LOGOUT = 'logout',
	LOGIN = 'login',
	REGISTER = 'register',
}
